import React from "react";
import UpsellManagement from "./UpsellManagement";

export default [
  {
    path: "/dashboard/upselling-management",
    exact: true,
    component: () => <UpsellManagement />
  }
];
